import React from 'react'
import PerioMain from '@components/pages/Charting/Perio/PerioMain.component'
import {
  PerioChartSectionData,
  PerioSection,
} from '@dataTypes/chartingFeature.types'
import { PerioVoiceHighlight, VoiceCursor } from '@utils/perio-keyword.utils'
import { GridComponent } from '@syncfusion/ej2-react-grids'

interface PerioPageProps {
  voiceStatus?: React.ReactNode
  voiceActive?: boolean
  chartingInfoFocusTick?: number
  voiceMeasurement?: React.ReactNode
  cursor: VoiceCursor
  voiceHighlight?: PerioVoiceHighlight
  onCursor: (patch: Partial<VoiceCursor>) => void
  chartIndex?: number
  onViewNote: (id: string, openFirstNote?: boolean) => void
  updatePerioValue: (
    section: PerioSection,
    label: keyof PerioChartSectionData,
    toothIndex: number,
    newValue: string,
  ) => void
  isFullscreen: boolean
  gridRef: React.RefObject<GridComponent>
  validationErrors: { [key: string]: string }
  setValidationErrors: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string
    }>
  >
}

const PerioPage = ({
  voiceStatus,
  voiceActive = false,
  chartingInfoFocusTick = 0,
  voiceMeasurement,
  cursor,
  voiceHighlight,
  onCursor,
  chartIndex = 0,
  onViewNote,
  updatePerioValue,
  isFullscreen,
  gridRef,
  validationErrors,
  setValidationErrors,
}: PerioPageProps): React.ReactElement => {
  return (
    <PerioMain
      voiceStatus={voiceStatus}
      voiceActive={voiceActive}
      chartingInfoFocusTick={chartingInfoFocusTick}
      voiceMeasurement={voiceMeasurement}
      voiceCursor={voiceHighlight}
      chartIndex={chartIndex}
      onViewNote={onViewNote}
      updatePerioValue={updatePerioValue}
      selectedTooth={cursor.tooth}
      setSelectedTooth={(tooth) => onCursor({ tooth })}
      selectedSection={cursor.section}
      setSelectedSection={(section) => onCursor({ section })}
      isFullscreen={isFullscreen}
      gridRef={gridRef}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
    />
  )
}

export default PerioPage
